module.exports = __webpack_public_path__ + "img/multi-product.02501764.png";